import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const progressCircle = document.querySelector(".autoplay-progress svg");
const progressContent = document.querySelector(".autoplay-progress span");


var interleaveOffset = 0.5;
const swiper = new Swiper('.mySwiper', {
  loop: false,
  initialSlide: 0,
  // effect: "coverflow",
  grabCursor: false,
  centeredSlides: true, 
  slidesPerView: "auto",
  // coverflowEffect: {
  //   rotate: 50,
  //   stretch: 0,
  //   depth: 100,
  //   modifier: 1,
  //   slideShadows: true,
  // },
  spaceBetween: 10,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false
  }, 
  modules: [Navigation, Pagination, Thumbs, Autoplay],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  on: {
    autoplayTimeLeft(s, time, progress) {
      progressCircle.style.setProperty("--progress", 1 - progress);
      progressContent.textContent = `${Math.ceil(time / 1000)}s`;
    },
    progress: function() {
      // var swiper = this;
      // for (var i = 0; i < swiper.slides.length; i++) {
      //     var slideProgress = swiper.slides[i].progress;
      //     var innerOffset = swiper.width * interleaveOffset;
      //     var innerTranslate = slideProgress * innerOffset;
      //     swiper.slides[i].querySelector(".slide-inner").style.transform =
      //     "translate3d(" + innerTranslate + "px, 0, 0)";
      // }
    },
    slideChangeTransitionStart: function () {
      $('.mySwiper .swiper-slide .slide-overlay').removeClass('show');
  },
  slideChangeTransitionEnd: function () {
      $('.mySwiper .swiper-slide-active .slide-overlay').addClass('show');
  } 
  }
});
